<template>
  <div class="onboarding-image d-flex justify-content-center align-items-center bg-white shadow-primary">
    <img
      :src
      :alt>
  </div>
</template>

<script setup>
defineProps({
  src: {
    type: String,
    required: true
  },
  alt: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.onboarding-image {
  border-radius: $sequin-border-radius;
  --shadow-margin: 6px;
  height: calc(100% - var(--shadow-margin, 0px));
  margin-bottom: var(--shadow-margin, 0px);

  img {
    max-height: 100%;
    pointer-events: none;
    user-select: none;
    object-fit: contain;

    // Image collapses to 0px on Safari <=17 when we set max-width
    // to 100% so we'll only set it on non-Safari browsers.
    @supports not (-webkit-touch-callout: none) {
      max-width: 100%;
    }
  }
}
</style>